/**
 * Category landing page — Planning hub.
 *
 * Calendar + Launch Checklist. Each underlying route still enforces its
 * own paywall via ProtectedRoute.
 */
import { Link } from "react-router-dom";
import { ArrowLeft, Calendar, ListChecks } from "lucide-react";
import { ToolGrid } from "./Communications";

const TOOLS = [
  {
    to: "/events",
    title: "Campaign Calendar",
    blurb: "Every event in one place — kickoff, parades, forums, Election Day.",
    icon: Calendar,
    tone: "red",
    testid: "planning-calendar",
  },
  {
    to: "/launch-checklist",
    title: "Launch Checklist",
    blurb: "Every step of running for office in order — eligibility through Election Day.",
    icon: ListChecks,
    tone: "navy",
    testid: "planning-checklist",
  },
];

export default function Planning() {
  return (
    <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-8 sm:py-10" data-testid="page-planning">
      <Link to="/dashboard" className="inline-flex items-center gap-1 text-sm font-semibold text-slate-600 hover:text-flag-navy">
        <ArrowLeft className="h-4 w-4" /> Back to home
      </Link>
      <div className="mt-4">
        <p className="text-xs font-bold uppercase tracking-[0.18em] text-flag-red">Planning</p>
        <h1 className="font-display text-3xl sm:text-4xl font-black text-flag-navy mt-1">Stay on top of every step.</h1>
        <p className="text-slate-600 mt-2 max-w-2xl text-base">Your roadmap for the cycle and your day-to-day campaign events — together so nothing slips.</p>
      </div>
      <ToolGrid tools={TOOLS} />
    </div>
  );
}
